// builder
import ClickStreamEvent from '@tekion/tekion-base/events/clickStream/builders/ClickStreamEvent';

// helpers
import { fireClickstreamEvent } from '@tekion/tekion-base/events/clickStream/helpers/clickStream.eventEmitter';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import CLICKSTREAM_EVENT_TYPES from '@tekion/tekion-base/events/clickStream/constants/clickstream.eventTypes';
import FILTER_TYPES from '../../constants/filterSection.filterTypes';
import WORKSPACE_FILTER_TYPES from '../../constants/filterSection.workspaceFilterTypes';

// Readers
import filterTypeReader from '../../readers/FilterType';
export var fireDefaultFilterChangeClickStreamEvent = function fireDefaultFilterChangeClickStreamEvent(_ref) {
  var module = _ref.module;
  var clickStreamEvent = new ClickStreamEvent(CLICKSTREAM_EVENT_TYPES.DEFAULT_FILTERS_CHANGE).setEventProperties({
    module: module
  });
  fireClickstreamEvent(clickStreamEvent);
};
var ALLOWED_FILTER_TYPES = new Set([FILTER_TYPES.SINGLE_SELECT, FILTER_TYPES.MULTI_SELECT, FILTER_TYPES.ASYNC_SINGLE_SELECT, FILTER_TYPES.ASYNC_MULTI_SELECT, FILTER_TYPES.DATE, FILTER_TYPES.DATE_WITHOUT_PRESET, FILTER_TYPES.DATE_TIME_WITHOUT_PRESET, FILTER_TYPES.DATE_PICKER, FILTER_TYPES.MONTH_PICKER, FILTER_TYPES.VIRTUALIZED_MULTI_SELECT, FILTER_TYPES.VIRTUALIZED_SELECT, WORKSPACE_FILTER_TYPES.WORKSPACE_ASYNC_MULTI_SELECT]);
export var isFilterOfSelectType = function isFilterOfSelectType() {
  var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var typeOfFilter = filterTypeReader.type(filter);
  var _ref2 = filterTypeReader.additional(filter) || EMPTY_OBJECT,
    isSelectTypeFilter = _ref2.isSelectTypeFilter;
  return ALLOWED_FILTER_TYPES.has(typeOfFilter) || isSelectTypeFilter;
};